export const IsAndroid = () => /(android)/i.test(navigator.userAgent);
export const IsFirefox = () => /(firefox)/i.test(navigator.userAgent);
export const IsIOSMobile = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
export const IsIPhoneSafari = () => /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && !/CriOS/.test(navigator.userAgent);
export const IsIPhoneNonSafari = () => /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && !/Version/.test(navigator.userAgent);
export const IsIPADDesktop = () => navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
export const IsIOS = () => IsIOSMobile() || IsIPADDesktop();
export const IsIOSSafari = () => IsIOS() && !/CriOS/.test(navigator.userAgent);
export const IsIPadSafari = () => ((/iPad/.test(navigator.userAgent) && !window.MSStream) || IsIPADDesktop()) && !/CriOS/.test(navigator.userAgent);
export const IsMobile = () => IsAndroid() || IsIOS();
export const IsIE11 = () => !!window.MSInputMethodContext && !!document.documentMode;
export const IsIE11Win7 = () => IsIE11() && /(NT 6.1)/i.test(navigator.userAgent);

export const ShouldGoFullscreen = () => IsAndroid();
export const ShouldGoFullscreenScroll = () => IsIPhoneSafari();

// Prevent scroll ish happening on IPhone safari, but it's controlled bu an additional overlay,
// is it is turned on and off depending on if the overlay is visible.
export const ShouldPreventScroll = () => IsIPhoneSafari() === false && IsAndroid() === false && IsFirefox() === false;
export const UseSimulatedScrolling = () => IsMobile();

export const GoFullscreen = () => {
    if (ShouldGoFullscreen()) {
        if (document.documentElement.requestFullscreen) {
            // W3C API
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            // Mozilla current API
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
            // Webkit current API
            document.documentElement.webkitRequestFullScreen();
        } // Maybe other prefixed APIs?
    }
};

const preventDefault = (evt) => {
    evt.preventDefault();
};

const overflowHidden = (state) => {
    const dom = [document.querySelector('body'), document.querySelector('html')];
    let classOverflow = '';

    if (state) classOverflow = 'no-overflow';

    dom.forEach((item) => {
        item.className = `${item.className.replace('no-overflow', '')} ${classOverflow}`; // eslint-disable-line no-param-reassign
    });
};

export const PreventScroll = (state = true) => {
    // modern Chrome requires { passive: false } when adding event
    let supportsPassive = false;
    try {
        window.addEventListener(
            'test',
            null,
            Object.defineProperty({}, 'passive', {
                get: () => {
                    supportsPassive = true;
                    return true;
                },
            })
        );
    } catch (e) {
        console.log(e);
    }

    const wheelOpt = supportsPassive ? { passive: false } : false;
    const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    if (state) {
        window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
        window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    } else {
        window.removeEventListener('DOMMouseScroll', preventDefault, false); // older FF
        window.removeEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.removeEventListener('touchmove', preventDefault, wheelOpt); // mobile
    }

    overflowHidden(state);
};

export const AddScroll = (elem) => {
    if (!ShouldPreventScroll() && !ShouldGoFullscreenScroll) return;
    const desktop = (e) => {
        const delta = e.wheelDelta || -e.detail;

        // eslint-disable-next-line no-param-reassign
        elem.scrollTop += delta * -1;

        e.stopPropagation();
    };

    elem.addEventListener('wheel', desktop);
    elem.addEventListener('mousewheel', desktop);
    elem.addEventListener('DOMMouseScroll', desktop);

    let lastY;
    let currentY;

    // reset touch position on touchstart
    elem.addEventListener('touchstart', (e) => {
        currentY = e.touches[0].clientY;
        lastY = currentY;
    });

    // get movement and scroll the same way
    elem.addEventListener('touchmove', (e) => {
        currentY = e.touches[0].clientY;
        const delta = currentY - lastY;

        // eslint-disable-next-line no-param-reassign
        elem.scrollTop += delta * -1;
        lastY = currentY;
    });
};

// Reload page to release memory if Win7 IE11
// https://github.com/facebook/react/issues/14272
export const ClearMemory = (reloadWin10) => {
    const shouldReload = reloadWin10 ? IsIE11() : IsIE11Win7();

    if (shouldReload) {
        setTimeout(() => {
            window.location.reload();
        }, 1);
    }
};

const LOW_POWER_DETECTED = 'low-power-detected';
const LOW_POWER_DIALOG = 'low-power-dialog';

const LOW_POWER_URL_WHITELIST = ['menu.html', 'connectivity.html#overview-incar', 'connectivity.html#inside'];

export const SetLowPowerMode = (isEnabled = true) => {
    const currentUrl = window.location.href;
    const isUrlWhitelisted = () => LOW_POWER_URL_WHITELIST.filter((url) => currentUrl.indexOf(url) > -1).length > 0;

    document.body.classList.add(LOW_POWER_DETECTED);

    if (isEnabled && !isUrlWhitelisted()) {
        document.body.classList.add(LOW_POWER_DIALOG);
    } else {
        document.body.classList.remove(LOW_POWER_DIALOG);
    }
};

export const IsLowPowerModeEnabled = () => document.body.classList.contains(LOW_POWER_DETECTED);

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return true;
    }

    return false;
};

export const reloadOTBanner = () => {
    console.log('reloadOTBanner');

    if (!getCookie('OptanonAlertBoxClosed')) {
        const otConsentSdk = document.getElementById('onetrust-consent-sdk');

        if (otConsentSdk) {
            otConsentSdk.remove();
        }

        if (window.OneTrust != null) {
            window.OneTrust.Init();

            setTimeout(() => {
                window.OneTrust.LoadBanner();

                const toggleDisplay = document.getElementsByClassName('ot-sdk-show-settings');

                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < toggleDisplay.length; i++) {
                    toggleDisplay[i].onclick = (event) => {
                        event.stopImmediatePropagation();
                        window.OneTrust.ToggleInfoDisplay();
                    };
                }
            }, 1000);
        }
    }
};
